import React from 'react'
import moment from 'moment'
import propTypes from 'prop-types'

import Input from 'components/Forms/Input'
import Button from 'components/Button'
import { FaTimes } from 'react-icons/fa'


export default function Datetime(props) {
  const startDatetime = props.startDatetime
  const endDatetime = props.endDatetime

  const [datetime, setDatetime] = React.useState({
    start: startDatetime,
    end: endDatetime,
  })
  const startRef = React.useRef(null)
  const endRef = React.useRef(null)

  const format = props.type === 'datetime' ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD'
  const type = props.type === 'datetime' ? 'datetime-local' : 'date'

  React.useEffect(() => {
    startRef.current.type = 'text'
    startRef.current.value = ''
    startRef.current.type = type

    setDatetime(datetime => ({
      ...datetime,
      start: startDatetime || null,
    }))
  }, [startDatetime]) // eslint-disable-line

  React.useEffect(() => {
    endRef.current.type = 'text'
    endRef.current.value = ''
    endRef.current.type = type

    setDatetime(datetime => ({
      ...datetime,
      end: endDatetime || null,
    }))
  }, [endDatetime]) // eslint-disable-line

  const onChange = (e, pointer, reset=false) => {
    setDatetime(datetime => {
      let ret = {}

      if (reset) {
        const refs = {
          start: startRef,
          end: endRef,
        }

        refs[pointer].current.type = 'text'
        refs[pointer].current.value = ''
        refs[pointer].current.type = type

        e.target.type = 'text'
        ret = {
          ...datetime,
          [pointer]: null,
        }

      } else {
        ret = {
          ...datetime,
          [pointer]: moment(e.target.value),
        }

      }

      props.onChange(ret)

      return ret
    })
  }

  return (
    <div className='flex w-full space-x-3'>
      <div className='flex-grow'>
        <label>
          <div className='mb-2 flex items-center space-x-3'>
            <span>From date</span>
            {
              (props.clearable && datetime.start) &&
              <Button onClick={e => onChange(e, 'start', true)} theme='danger'><FaTimes /></Button>
            }
          </div>
          <Input
            ref={startRef}
            onChange={e => onChange(e, 'start')}
            inputProps={{
              type,
              max: datetime.end?.format(format),
              value: datetime.start?.format(format),
            }}
          />
        </label>
      </div>
      <div className='flex-grow'>
        <label>
          <div className='mb-2 flex items-center space-x-3'>
            <span>To date</span>
            {
              (props.clearable && datetime.end) &&
              <Button onClick={e => onChange(e, 'end', true)} theme='danger'><FaTimes /></Button>
            }
          </div>
          <Input
            ref={endRef}
            onChange={e => onChange(e, 'end')}
            inputProps={{
              type,
              min: datetime.start?.format(format),
              value: datetime.end?.format(format),
            }}
          />
        </label>
      </div>
    </div>
  )
}


Datetime.propTypes = {
  startDatetime: propTypes.instanceOf(moment),
  endDatetime: propTypes.instanceOf(moment),
  type: propTypes.oneOf(['date', 'datetime']),
  clearable: propTypes.bool,
  onChange: propTypes.func,
}

Datetime.defaultProps = {
  type: 'datetime',
  onChange: () => {},
}
